import { render } from "./event-batch-channel-creating.vue?vue&type=template&id=62d5d5b1&lang=pug"
import script from "./event-batch-channel-creating.vue?vue&type=script&lang=js"
export * from "./event-batch-channel-creating.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__